//import Swal from 'sweetalert2'

const { parseJSON } = require("jquery");

$(document).ready(function() {
    const companies = {
        isLoading: false,
        init() {
            $(document).on('click', '#add-new-address', this, this.addNewAddress);
            $(document).on('click', '#cancel-new-address', this, function() {
				$('#new-address-form-wrapper').hide();
			});
            $(document).on('click', '.cancel-edit-address', this, function() {
				var id = $(this).data('id');

				$('#address-' +id).find('.form-control').prop('disabled', true);
				$('#address-' +id).find('.edit-address').show();
				$('#address-' +id).find('.save-address').hide();
				$('#address-' +id).find('.cancel-edit-address').hide();
				$('#address-' +id).find('.edit-address-select2').select2({
					disabled: true
				});
			});
            $(document).on('click', '.edit-address', this, this.editAddress);
            $(document).on('click', '.save-address', this, this.updateAddress);
            $(document).on('click', '#save-new-address', this, this.saveAddress);
            $(document).on('click', '.delete-address', this, this.deleteAddress);

			$('.edit-address-select2').select2({
				disabled: true
			});

			$(document).on('change', '#county_id', this, this.getCities);
			$(document).on('change', '.edit-county-id', this, this.getCities);
        },
		editAddress(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }
			var element = this;

			$(element).hide();
			$('#address-' +id).find('.form-control').removeAttr('disabled');
			$('#address-' +id).find('.cancel-edit-address').show();
			$('#address-' +id).find('.save-address').show();
			$('#address-' +id).find('.edit-address-select2').select2({
				disabled: false
			});

		},
		updateAddress(event) {
            const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

            if (_this.isLoading) {
                return false;
            }

            $('#address-' + id).find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#edit-first-name-' + id).val() == '') {
				$('#edit-first-name-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-last-name-' + id).val() == '') {
				$('#edit-last-name-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-phone-' + id).val() == '') {
				$('#edit-phone-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-email-' + id).val() == '') {
				$('#edit-email-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-county-id-'+id+' option:selected').val() == '') {
				$('#edit-county-id-'+id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-city-id-'+id+' option:selected').val() == '') {
				$('#edit-city-id-'+id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-address-' + id).val() == '') {
				$('#edit-address-' + id).addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

			var values = '_token=' + $('#_token_address_list').val();
            values += '&id=' + id;
            values += '&first_name=' + $('#edit-first-name-' + id).val();
            values += '&last_name=' + $('#edit-last-name-' + id).val();
            values += '&phone=' + $('#edit-phone-' + id).val();
            values += '&email=' + $('#edit-email-' + id).val();
			values += '&county_id=' + $('#edit-county-id-' + id + ' option:selected').val();
			values += '&city_id=' + $('#edit-city-id-' + id + ' option:selected').val();
            values += '&address=' + $('#edit-address-' + id).val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-address`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {

						$('#address-' +id).find('.form-control').prop('disabled', true);
						$('#address-' +id).find('.edit-address').show();
						$('#address-' +id).find('.save-address').hide();
						$('#address-' +id).find('.cancel-edit-address').hide();
						$('#address-' +id).find('.address-name').text(response.data.first_name+' '+response.data.last_name);
						$('#address-' +id).find('.edit-address-select2').select2({
							disabled: true
						});

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						return;
                    }

					Swal.fire({
						// icon: 'error',
						// title: 'Error!',
						html: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },
        deleteAddress(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			Swal.fire({
				title: $('#addresses-container').data('delete-title'),
				text: $('#addresses-container').data('delete-text'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: $('#addresses-container').data('delete-btn-yes'),
				cancelButtonText: $('#addresses-container').data('delete-btn-no')
			}).then((result) => {

				if (!result.isConfirmed) {
					return false;
				}

				if (_this.isLoading) {
	                return false;
	            }

				//Loading...
	            _this.isLoading = true;

	            var values = '_token=' + $('#_token_address_list').val();
				values += '&id=' + id;
	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/delete-address`,
	                data: values,
	                beforeSend: function() {
	                    _this.isLoading = true;
	                },
	                complete: function() {
	                    _this.isLoading = false;
	                },
	                success: function(response, xhr) {
	                    _this.isLoading = false;

	                    if (response.status == 1) {
							$('#address-' + id).remove();
							Swal.fire(
								$('#addresses-container').data('delete-success-title'),
								$('#addresses-container').data('delete-success-text'),
								// 'success'
		    				);

							if ($('#addresses-container').children().length == 0){
								$('#addresses-container').html('<p class="empty">'+$('#addresses-container').data('empty-text')+'</p>');
							} else {
								//console.log('is not epmtpy');
							}

							return;
	                    }
	                },
	                error(error) {
	                    _this.isLoading = false;
	                },
	            });

  				//if (result.value) {}
			});
		},
        addNewAddress(event) {
			const _this = event.data;

			$('#new-address-form-wrapper').show();

			$('#county_id').select2();
			$('#city_id').select2();
		},
        saveAddress(event) {
            const _this = event.data;
			const source = $(this).data('source');

            if (_this.isLoading) {
                return false;
            }

            $('.form-new-address').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#first_name').val() == '') {
				$('#first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#last_name').val() == '') {
				$('#last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#address').val() == '') {
				$('#address').addClass('is-invalid');
				errors = true;
			}
			if ($('#county_id option:selected').val() == '') {
				$('#county_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#city_id option:selected').val() == '') {
				$('#city_id').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $('#_token_address').val();
            values += '&first_name=' + $('#first_name').val();
            values += '&last_name=' + $('#last_name').val();
            values += '&phone=' + $('#phone').val();
            values += '&email=' + $('#email').val();
			values += '&county_id=' + $('#county_id option:selected').val();
			values += '&city_id=' + $('#city_id option:selected').val();
            values += '&address=' + $('#address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/address`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						$('.empty').remove();

						var selectOptions = '';
						for (var i in statesArray) {
							var selectedOption = '';
							if (statesArray[i].id == response.data.county_id) {
								selectedOption = 'selected="selected"';
							}
							selectOptions += '<option value="'+statesArray[i].id+'" '+selectedOption+' data-cities="'+statesArray[i].cities.replace(/"/g, '&quot;')+'">'+statesArray[i].name+'</option>';
						}

						var selectCityOptions = '';
						for (var i in response.data.cities) {
							var selectedOption = '';
							if (response.data.cities[i].id == response.data.city_id) {
								selectedOption = 'selected="selected"';
							}
							selectCityOptions += '<option value="'+response.data.cities[i].id+'" '+selectedOption+'>'+response.data.cities[i].name+'</option>';
						}

						var rowHtml = `<div id="address-${response.data.id}" class="mb-4">
							<div class="section-divider row mb-4">
								<div class="col-auto address-name">${response.data.first_name} ${response.data.last_name}</div>
								<div class="col line"></div>
							</div>
							<div class="row">
								<div class="col-md-6 mb-3">
									<label for="edit-first-name-${response.data.id}" class="form-label">Prenume</label>
									<input type="text" class="form-control" name="edit-first-name-${response.data.id}" id="edit-first-name-${response.data.id}" value="${response.data.first_name}" disabled>
								</div>
								<div class="col-md-6 mb-3">
									<label for="edit-last-name-${response.data.id}" class="form-label">Nume</label>
									<input type="text" class="form-control" name="edit-last-name-${response.data.id}" id="edit-last-name-${response.data.id}" value="${response.data.last_name}" disabled>
								</div>
								<div class="col-md-6 mb-3">
									<label for="edit-phone-${response.data.id}" class="form-label">Telefon</label>
									<input type="text" class="form-control" name="edit-phone-${response.data.id}" id="edit-phone-${response.data.id}" value="${response.data.phone}" disabled>
								</div>
								<div class="col-md-6 mb-3">
									<label for="edit-email-${response.data.id}" class="form-label">E-mail</label>
									<input type="text" class="form-control" name="edit-email-${response.data.id}" id="edit-email-${response.data.id}" value="${response.data.email}" disabled>
								</div>
								<div class="col-md-6 mb-3">
									<label for="edit-county-id-${response.data.id}" class="form-label">Judet</label>
									<select class="form-select edit-address-select2 template-light edit-county-id" data-id="${response.data.id}" name="edit-county-id-${response.data.id}" id="edit-county-id-${response.data.id}">
										<option value="">Selecteaza</option>
										${selectOptions}
									</select>
								</div>
								<div class="col-md-6 mb-3">
									<label for="edit-city-id-${response.data.id}" class="form-label">Oraș</label>
									<select class="form-select edit-address-select2 template-light" name="edit-city-id-${response.data.id}" id="edit-city-id-${response.data.id}">
										<option value="">Selecteaza</option>
										${selectCityOptions}
									</select>
								</div>
								<div class="col-md-12 mb-3">
									<label for="edit-address-${response.data.id}" class="form-label">Adresa</label>
									<input type="text" class="form-control" name="edit-address-${response.data.id}" id="edit-address-${response.data.id}" value="${response.data.address}" disabled>
								</div>
							</div>
							<div class="row mx-0 mt-4">
								<button type="button" data-id="${response.data.id}" style="padding: 10px 20px!important;font-size:12px!important; display: none;"
									class="save-address btn purple-btn col-md-4 rounded-pill text-uppercase me-md-3 mb-3 mb-md-0"><i class="fa fa-spinner fa-spin" aria-hidden="true" style="display:none"></i>Salvează</button>
								<button style="padding: 10px 20px!important;font-size:12px!important; display: none;" data-id="${response.data.id}" 
									class="cancel-edit-address btn purple-btn-outline col-md-3 rounded-pill me-md-3 mb-md-0">cancel</button>
								<button type="button" data-id="${response.data.id}" style="padding: 10px 20px!important;font-size:12px!important" 
									class="edit-address btn purple-btn col-md-3 rounded-pill me-md-3 mb-md-0">Editează</button>
								<button type="button" data-id="${response.data.id}" style="padding: 10px 20px!important;font-size:12px!important" 
									class="delete-address btn btn-outline-danger col-md-3 rounded-pill">Sterge</button>
							</div>
						</div>`;
						$('#addresses-container').prepend(rowHtml);

						$('#new-address-form-wrapper').hide();
						$('#form-new-address').find('.form-control').val('');

						$('.edit-address-select2').select2({
							disabled: true
						});

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						return;
                    }
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },
		getCities() {
			var cityElementName = '#city_id';
			var idState = $(this).attr('id');
			if ($(this).hasClass('edit-county-id')) {
				cityElementName = '#edit-city-id-' + $(this).data('id');
			}

			$(cityElementName).find('option:not(:first)').remove();

			if ($('#'+idState+' option:selected').val() == '') {
				return;
			}

			let cities = $('#'+idState+' option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
				return cities[key];
			});
			for (var i in cities) {
				$(cityElementName).append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
    };

    if ($('.account-addresses-section').length) {
        companies.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/addresses.js